import { inject, Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { ColDef } from 'ag-grid-community';
import { GridUtilitiesService } from '../services/grid-utilities.service';
import { BehaviorSubject } from 'rxjs';
import { getSePatientName, getSePatientSurname } from '../utils/utils';

@Injectable({
    providedIn: 'root',
})
export class SeResignModalService {
    readonly dialog = inject(MatDialog);
    private gridDataSubject = new BehaviorSubject<any[]>([]);
    gridData$ = this.gridDataSubject.asObservable();

    constructor(
        private translate: TranslateService,
        private gridUtils: GridUtilitiesService,
    ) {}

    setCDADataForGrid(data: any) {
        this.gridDataSubject.next(data);
    }

    cdaColumnDefs(): ColDef[] {
        let columns: Array<ColDef> = [];
        columns = [
            {
                colId: '0',
                headerName: this.translate.instant('Patient'),
                headerTooltip: this.translate.instant('Patient'),
                valueGetter: (e) =>
                    `${getSePatientSurname(e.data.patient).toLocaleUpperCase()} ${getSePatientName(e.data.patient).toLocaleUpperCase()}`,
                tooltipValueGetter: (e) =>
                    `${getSePatientSurname(e.data.patient).toLocaleUpperCase()} ${getSePatientName(e.data.patient).toLocaleUpperCase()}`,
                width: 200,
                minWidth: 190,
                flex: 1,
            },
            {
                colId: '1',
                headerName: this.translate.instant('Description'),
                headerTooltip: this.translate.instant('Description'),
                tooltipField: 'exam.description',
                field: 'exam.description',
                width: 200,
                minWidth: 190,
                flex: 1,
            },
            {
                colId: '2',
                headerName: this.translate.instant('ExamDate'),
                headerTooltip: this.translate.instant('ExamDate'),
                tooltipValueGetter: (p) => p.valueFormatted,
                field: 'examinationDate',
                width: 140,
                minWidth: 120,
                flex: 1,
                valueFormatter: this.gridUtils.dateTimeFormatter('examinationDate'),
                comparator: this.gridUtils.dateComparator,
            },
            {
                colId: '3',
                headerName: this.translate.instant('ReportDate'),
                headerTooltip: this.translate.instant('ReportDate'),
                tooltipValueGetter: (p) => p.valueFormatted,
                field: 'reportDate',
                width: 140,
                minWidth: 120,
                flex: 1,
                valueFormatter: this.gridUtils.dateTimeFormatter('reportDate'),
                comparator: this.gridUtils.dateComparator,
            },
        ];
        return columns;
    }

    close() {
        this.dialog.closeAll();
        this.dialog.ngOnDestroy();
    }
}
